// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"641":"a4637d232f9372fbfa6a","805":"930e509536c0e25c68cd","866":"d4362ebbab789e4cc4f5"}[chunkId] + ".css";
};